import API from "@/interceptors/Api";
import type { DatanomikUser } from "../types/role.types";

export const getAllCashPoolingUsers = async (): Promise<DatanomikUser[]> => {
  const response = await API.get("/cash-pooling/users");
  return response as unknown as DatanomikUser[];
};
